<template>
    <div class="patient-admin mt-page">

        <div class="patient-admin__header">

            <h1>{{ $i18n.gt('HEADING_OUR_PATIENTS') }}</h1>

            <div class="patient-admin__header__buttons">
                <router-link class="link-icon btn btn-ghost-blue mr-3"
                             to="/patient/create">
                    {{ $i18n.gt('BUTTON_NEW_PATIENT') }}
                    <shs-icon name="plus"></shs-icon>
                </router-link>
                <router-link class="link-icon btn btn-ghost-blue mr-3"
                             to="/provider/create">
                    {{ $i18n.gt('BUTTON_ADOPT_PATIENT') }}
                    <shs-icon name="person"></shs-icon>
                </router-link>
                <router-link class="btn btn-ghost-blue mr-3"
                             :to="`/participant/importForPractice/practiceId/${$user.practitionerPracticeId()}`">
                    {{ $i18n.gt('BUTTON_IMPORT_PATIENT') }}
                    <shs-icon name="spreadsheet"></shs-icon>
                </router-link>

                <router-link class="btn btn-ghost-blue mr-3"
                             :to="`/biometrics/practiceId/${$user.practitionerPracticeId()}`">
                    {{ $i18n.gt('BUTTON_BIOMETRICS') }}
                    <shs-icon name="beaker"></shs-icon>
                </router-link>

                <router-link class="btn btn-ghost-blue"
                             :to="`/rpm/${$user.practitionerPracticeId()}`">
                    {{ $i18n.gt('BUTTON_RPM') }}
                    <shs-icon name="monitor"></shs-icon>
                </router-link>
            </div>
        </div>

        <!-- patient list -->

        <div class="practitioner-patients__table">
            <patient-list :filter-value="filterValue"></patient-list>
        </div>
    </div>

</template>

<script>

    import Vue from 'vue'

    /**
     * Page for a Practitioner to manage the Participants belonging to their Practice (via Provider links)
     */
    export default Vue.extend({
        name: 'PatientAdmin',
        props: {
            filterValue: String,
        }
    })
</script>

<style lang="scss">
    .patient-admin__header {
        //margin-top: -2em;
        margin-bottom: .5em;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: row;
    }

    .patient-admin__header__buttons {
        @media (max-width: 767px) {
            .btn:first-child {
                margin-bottom: .5em;
            }
        }
        @media (min-width: 768px) {
            display: flex;
        }
    }

</style>
